export default function Marquee({ items, dark = false, slow = false, testid = "marquee" }) {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden py-7" data-testid={testid}>
      <div className={`flex w-max items-center ${slow ? "animate-marquee-slow" : "animate-marquee"} hover:[animation-play-state:paused]`}>
        {row.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span
              className={`font-display text-xl sm:text-2xl font-medium tracking-wide px-8 ${
                dark ? "text-white/60" : "text-ink/40"
              }`}
            >
              {item}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-gold shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}
